import { Badge } from '@vnetwork/ui/primitives';
import type { TicketDetail } from '@/api/support';

function Fact({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div style={{ display: 'grid', gap: 2, minWidth: 0 }}>
      <span style={{ fontSize: 'var(--vn-font-size-xs)', color: 'var(--vn-fg-muted)' }}>
        {label}
      </span>
      <span
        style={{
          fontSize: 'var(--vn-font-size-sm)',
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {children}
      </span>
    </div>
  );
}

const dash = <span style={{ color: 'var(--vn-fg-muted)' }}>—</span>;

/** Compact horizontal customer/service facts strip, shown above the description. */
export function TicketFacts({ ticket }: { ticket: TicketDetail }) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px 36px',
        padding: '12px 16px',
        background: 'var(--vn-bg-subtle)',
        border: '1px solid var(--vn-border-default)',
        borderRadius: 'var(--vn-radius-lg)',
      }}
    >
      <Fact label="Customer">{ticket.company_name || dash}</Fact>
      <Fact label="Service">
        {ticket.service_name ? (
          <>
            {ticket.service_name}
            {ticket.service_id ? (
              <span style={{ color: 'var(--vn-fg-muted)' }}> · #{ticket.service_id}</span>
            ) : null}
          </>
        ) : (
          dash
        )}
      </Fact>
      <Fact label="Product">
        {ticket.product_group_name || ticket.ticket_product_name || dash}
      </Fact>
      <Fact label="Service status">
        {ticket.service_status ? (
          <Badge tone="neutral" appearance="subtle" size="sm">
            {ticket.service_status}
          </Badge>
        ) : (
          dash
        )}
      </Fact>
    </div>
  );
}
